/**
 * @file component-td-product-recommendations.js
 * @description Product recommendations web component for Hi-Neighbor Theme
 * @version 1.1.0
 * 
 * A standalone Shopify 2.0 compatible product recommendations component
 * that uses the Shopify recommendations API and displays products in a swiper slider.
 * 
 * Follows project conventions with 'td-' prefix for components and 'td:' for events.
 */

if (!customElements.get('td-product-recommendations')) {
  class TdProductRecommendations extends HTMLElement {
    observer = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      if (!this.dataset.url) {
        console.warn('TD Product Recommendations: Missing required attributes');
        return;
      }
      
      this.initializeRecommendations();
    }

    initializeRecommendations() {
      // Clean up existing observer if any
      this.observer?.unobserve(this);
      
      // Create new observer
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.observer = undefined; // Clear the reference after use
          this.loadRecommendations();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      
      this.observer.observe(this);
    }

    loadRecommendations() {
      fetch(this.dataset.url)
        .then(response => {
          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
          return response.text();
        })
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          
          // Find the recommendations content
          const recommendations = html.querySelector('td-product-recommendations');
          
          if (recommendations?.innerHTML.trim().length) {
            // Replace the entire inner content
            this.innerHTML = recommendations.innerHTML;
            
            // Initialize the swiper
            this.initializeSwiper();
          }
        })
        .catch(error => {
          console.error('Error loading product recommendations:', error);
          this.style.display = 'none';
        });
    }

    initializeSwiper() {
      const swiperElement = this.querySelector('swiper-slider');
      if (!swiperElement) return;
      swiperElement.dispatchEvent(new CustomEvent('reinitialize-swiper'));
    }
  }

  customElements.define('td-product-recommendations', TdProductRecommendations);
}
